module.exports = __webpack_public_path__ + "static/media/YF16_5.2acf9676.jpg";